import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Container, Section, Stack } from '@fiverr-private/layout_components';
import { Text, Typography } from '@fiverr-private/typography';
import { Content } from '../Content';
import { headerContainer } from './styles.ve.css';

interface Props {
    title: string;
    description: string;
    professionAliasPlural: string;
    isDefaultLocale: boolean;
}

const TRANSLATIONS_KEY = 'skill_page_perseus.hero_banner';

export const HeroBanner: React.FC<Props> = ({ title, description, professionAliasPlural, isDefaultLocale }) => {
    const italicTemplate = {
        italic: (text: string | undefined) => <em>{text}</em>,
    };

    return (
        <Section
            backgroundColor="green_1100"
            fullWidth
            paddingTop={{ default: '7', sm: '8', md: '14' }}
            paddingBottom={{ default: '9', sm: '8', md: '16' }}
        >
            <Stack
                direction="column"
                centered
                gap="0"
                paddingTop="0"
                paddingBottom="0"
                padding="0"
                paddingLeft="8"
                paddingRight="6"
            >
                {title ? (
                    <Container marginBottom={{ default: '1', sm: '2' }}>
                        <Content color="white" className={headerContainer} isIndependent={true} plainHtml={title} />
                    </Container>
                ) : (
                    <Typography
                        className={headerContainer}
                        color="white"
                        as="h1"
                        marginBottom={{ default: '1', sm: '2' }}
                    >
                        <I18n
                            k={`${TRANSLATIONS_KEY}.${isDefaultLocale ? 'title' : 'title_localized'}`}
                            templates={italicTemplate}
                            params={{ category: professionAliasPlural }}
                        />
                    </Typography>
                )}
                {description ? (
                    <Content isIndependent={true} color="white" plainHtml={description} />
                ) : (
                    <Text color="white">
                        <I18n
                            k={`${TRANSLATIONS_KEY}.${isDefaultLocale ? 'description' : 'description_localized'}`}
                            params={{ category: professionAliasPlural }}
                        />
                    </Text>
                )}
            </Stack>
        </Section>
    );
};
